import { CustomObservables } from "app/custom-observables";
import * as ko from "knockout";
import * as _ from "lodash";
import { person } from "./person";
import { team_member } from "../team/team_member";

export class personExtended extends person {
  team_member: KnockoutObservableArray<team_member>;
  role_list: KnockoutObservable<string>;
  placepersons: KnockoutObservable<any>;
  description: KnockoutComputed<string>;
  status: KnockoutObservable<string>;
  language: KnockoutObservable<any>;
  locale_code: KnockoutObservable<any>;
  department: KnockoutObservable<any>;
  job_title: KnockoutObservable<any>;
  place_id: KnockoutObservable<any>;
  company: KnockoutObservable<any>;
  fax: KnockoutObservable<any>;
  mobile_phone: KnockoutObservable<any>;
  salutation: KnockoutObservable<any>;
  user_def4: KnockoutObservable<any>;
  created_dttm: KnockoutObservable<Date>;
  formattedcreated_dttm: any;
  statusCode: KnockoutObservable<string>;
  user_def17: KnockoutObservable<string>;

  constructor(item: any) {
    super(item);
    this.salutation = ko.observable(item?.salutation);
    this.locale_code = ko.observable(item?.locale_code);
    this.mobile_phone = ko.observable(item?.mobile_phone);
    this.fax = ko.observable(item?.fax);
    this.job_title = ko.observable(item?.job_title);
    this.status = ko.observable(item?.status);
    this.user_def4 = ko.observable(item?.user_def4);

    this.description = ko.pureComputed(() => {
      return this.first_name() + " " + this.last_name();
    });

    this.role_list = ko.observable(
      _.join(
        _.map(item.person_role, (role) => {
          if (role.user_role && role.user_role instanceof Array && role.user_role[1].user_def3 === "Y") {
            return role.user_role[1].description;
          }
          if (role[1] && role[1].user_def3 === "Y") return role[1].description;
        }).filter((role) => role),
        ", "
      )
    );
    this.placepersons = ko.observable(item?.person_id);
    this.team_member = <KnockoutObservableArray<team_member>>(
      this.loadRelation(item, team_member, "team_member", "array")
    );
    this.created_dttm = ko.observable(this.formatJSONDate(item?.created_dttm));
    this.formattedcreated_dttm = CustomObservables.formattedDateTimeObservable(this?.created_dttm);
    this.statusCode = ko.observable(item?.statusCode);
    this.user_def17 = ko.observable(item?.user_def17 ? item?.user_def17 : "");
  }
}
